export enum BookingType {
  Online = 'Online',
  InPerson = 'In-Person'
}
